import { useLanguage } from "@certn/auth/src/hooks/useLanguage";

/** Keeps `document.documentElement.lang` in sync on routes that omit the footer. */
export function DocumentLanguageSync() {
  useLanguage();
  return null;
}
